import { useEffect, useMemo, useState } from "react";
import { useI18n } from "../i18n/LanguageContext";

import { resolvePaymentPresentation } from "../config/prelaunch";
import { fetchMonetizationStatus } from "./monetizationApi";


export default function usePaymentPublicStatus() {
  const { t } = useI18n();
  const [presentation, setPresentation] = useState(() =>
    resolvePaymentPresentation(null)
  );

  useEffect(() => {
    let controller;
    let stopped = false;
    const refresh = () => {
      controller?.abort();
      controller = new AbortController();
      const signal = controller.signal;
      fetchMonetizationStatus({ signal })
      .then((capabilities) => {
        if (!stopped && !signal.aborted) {
          setPresentation(resolvePaymentPresentation(capabilities));
        }
      })
      .catch(() => {
        if (!stopped && !signal.aborted) setPresentation(resolvePaymentPresentation(null));
      });
    };
    const onVisible = () => { if (document.visibilityState === "visible") refresh(); };
    refresh();
    const timer = window.setInterval(onVisible, 60_000);
    window.addEventListener("online", refresh);
    document.addEventListener("visibilitychange", onVisible);

    return () => {
      stopped = true;
      controller?.abort();
      window.clearInterval(timer);
      window.removeEventListener("online", refresh);
      document.removeEventListener("visibilitychange", onVisible);
    };
  }, []);

  return useMemo(() => ({
    ...presentation,
    bannerBadge: t(`shell.payments.${presentation.state}.badge`, presentation.bannerBadge),
    bannerMessage: t(`shell.payments.${presentation.state}.message`, presentation.bannerMessage),
    navigationLabel: t(`shell.payments.${presentation.state}.navigation`, presentation.navigationLabel),
  }), [presentation, t]);
}
